import React,{useState, useEffect} from 'react'
import '../Cards/DetailCard.scss'
import Card from './Card'
import { connect } from 'react-redux';
import Modal from '@mui/material/Modal';
import BackButton from '../../common/BackButton';
import SearchButton from '../../common/SearchButton';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import urls from '../../../utils/url';
import Loader from '../../common/loader';
import CentralMonitorError from '../../../pages/error/centralMonitorError';
import Cookie from 'js-cookie';
import NavamCard from '../NavamCMS/NavamCard';

const DetailCard = ({keyarData}) => {

 // console.log(keyarData)

  const navigate = useNavigate();

  const cookie = Cookie.get('access_token');
  const cookieData = Cookie.get('data');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [data, setData] = useState([]);
  const [accountType, setAccountType] = useState('');

  useEffect(() => {
    if (cookieData) {
      const parsedData = JSON.parse(cookieData);
      // const accessToken = cookieValue.access_token;
      //const algorithm = parsedData.fetal_distress_algorithm;
      const account_type = parsedData.account_type;
      setAccountType(account_type); 
    }
  }, [cookieData])
  
  useEffect(() => {
    const temp_keyar_data = [...keyarData].sort((a, b) => a.patientID - b.patientID);

    const currentTime = Date.now();
    const sixtyMinutesAgo = currentTime - (60 * 60 * 1000);

    const filteredPatients = temp_keyar_data.filter(patient => {
      // Check each patient's keyarData for any latest_data timestamps within the last 60 minutes
      return patient.keyarData.some(dataItem => {
        return Object.keys(dataItem.latest_data).some(timestamp => {
          return parseInt(timestamp) >= sixtyMinutesAgo;
        });
      });
    });


    setData(filteredPatients)

    if (filteredPatients.length > 0){
      setError(false)
    } else {
      setError(true)
    }

  }, [keyarData])



  return (
    <>
    {
      loading ? 
        <div style={{marginTop: '20%', position: 'relative'}}>
          <Loader/>
        </div>
      : 
        
        <div className="main">
          <div className="cms-header">
            {/* <div onClick={back}>
              <BackButton/>
            </div> */}
            
            <p className='real-time-monitoring'>Real Time Monitoring</p>

            <div></div>
            {/* <div className='search-div'>
              <SearchButton/>
              {/* <img src="/three-dots.png" alt="" className='threedots' onClick={handleOpen}/>
              <Modal open={open} onClose={handleClose}>
                <div className='modal' style={{width: '100px', backgroundColor: '#FFF', height: '30px', border: 'none', left: '93%', position: 'relative', top: '55px'}}>
                  <p style={{textAlign: 'center', fontFamily: 'Poppins, sans-serif', padding: '5px'}} onClick={logout}>Log Out</p>
                </div>
              </Modal> */}
          </div>
          
          { data && data !== undefined && data.length > 0 ? 
            <div className='grid'>
              {
                data.map( (obj,key) => (

                  (accountType && accountType === 'Navam' ? 
                   <NavamCard props={obj} key={key}/> 
                   :
                   <Card props={obj} key={key}/> 
                  )
                ))
              }
            </div>
            :
            error ? 
              <CentralMonitorError/>
            :
              <div/>
          }  
        </div>
    }
    </>

    
  )
}


const mapStateToProps = (state) => ({
  keyarData: state.keyarData.keyarData,
});

export default connect(mapStateToProps)(DetailCard)